// --- internal
import actions from "./actions";
import services from "./services";
// -----------------------------------------------------------------------------
export default {
  actions,
  services
};
